const Trash = () => {
  return (
    <svg
      data-testid="trash-svg-icon"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 16V7" stroke="#111111" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 16V7" stroke="#111111" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 16V7" stroke="#111111" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.5 3.5H15.5" stroke="#111111" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11 3.25V2.5C11 1.96957 10.7893 1.46086 10.4142 1.08579C10.0391 0.710714 9.53043 0.5 9 0.5H7C6.46957 0.5 5.96086 0.710714 5.58579 1.08579C5.21071 1.46086 5 1.96957 5 2.5V3.25"
        stroke="#111111"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 3.125V18C14.5 18.3978 14.342 18.7794 14.0607 19.0607C13.7794 19.342 13.3978 19.5 13 19.5H3C2.60218 19.5 2.22064 19.342 1.93934 19.0607C1.65804 18.7794 1.5 18.3978 1.5 18V3.125"
        stroke="#111111"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Trash;
